import { createAction, createReducer } from 'redux-act';

const DEFAULT_STATE = { descriptionMap: {} };

export const setDescriptionMapAction = createAction('SET_DESCRIPTION_MAP');

export const descriptionCacheReducer = createReducer(function (on, off) {
  on(setDescriptionMapAction, (state, payload) => {
    return {
      descriptionMap: payload
    }
  });
}, DEFAULT_STATE);


export function setDescriptionMap(map) {
  return dispatch => {
    dispatch(setDescriptionMapAction(map));
  }
}
